import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Plus, Trash2, Copy } from 'lucide-react';

/** Step 2 wizard: punti vendita del cliente. */
export default function WizardStepPuntiVendita({ puntiVendita, onAdd, onUpdate, onRemove, onCopyAddress }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Aggiungi i punti vendita del cliente (negozi, ristoranti, sedi operative).
        Puoi saltare questo passaggio se non necessario.
      </p>

      {puntiVendita.map((punto, index) => (
        <div key={punto._uid || `pv-${index}`} className="border border-border p-4 space-y-3">
          <div className="flex justify-between items-center">
            <h4 className="font-bold text-sm">Punto Vendita #{index + 1}</h4>
            <div className="flex items-center gap-1">
              <Button
                variant="outline"
                size="sm"
                className="rounded-none text-xs h-8"
                onClick={() => onCopyAddress(index)}
                title="Copia indirizzo legale del cliente"
                data-testid={`wizard-punto-copy-address-${index}`}
              >
                <Copy className="h-3 w-3 mr-1" />
                Usa indirizzo cliente
              </Button>
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8 rounded-none text-destructive"
                onClick={() => onRemove(index)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <Label className="text-xs font-mono uppercase">Nome *</Label>
              <Input
                value={punto.nome}
                onChange={(e) => onUpdate(index, 'nome', e.target.value)}
                placeholder="Es: Negozio Centro, Ristorante Via Roma"
                className="rounded-none"
                data-testid={`wizard-punto-nome-${index}`}
              />
            </div>
            <div>
              <Label className="text-xs font-mono uppercase">Città *</Label>
              <Input
                value={punto.citta}
                onChange={(e) => onUpdate(index, 'citta', e.target.value)}
                className="rounded-none"
                data-testid={`wizard-punto-citta-${index}`}
              />
            </div>
            <div className="md:col-span-2">
              <Label className="text-xs font-mono uppercase">Indirizzo *</Label>
              <Input
                value={punto.indirizzo}
                onChange={(e) => onUpdate(index, 'indirizzo', e.target.value)}
                className="rounded-none"
                data-testid={`wizard-punto-indirizzo-${index}`}
              />
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div>
                <Label className="text-xs font-mono uppercase">CAP</Label>
                <Input
                  value={punto.cap}
                  onChange={(e) => onUpdate(index, 'cap', e.target.value)}
                  className="rounded-none"
                />
              </div>
              <div>
                <Label className="text-xs font-mono uppercase">Prov.</Label>
                <Input
                  value={punto.provincia}
                  onChange={(e) => onUpdate(index, 'provincia', e.target.value)}
                  className="rounded-none"
                  maxLength={2}
                />
              </div>
            </div>
            <div>
              <Label className="text-xs font-mono uppercase">Referente</Label>
              <Input
                value={punto.referente_nome}
                onChange={(e) => onUpdate(index, 'referente_nome', e.target.value)}
                className="rounded-none"
                placeholder="Nome referente"
              />
            </div>
            <div>
              <Label className="text-xs font-mono uppercase">Tel. Referente</Label>
              <Input
                value={punto.referente_telefono}
                onChange={(e) => onUpdate(index, 'referente_telefono', e.target.value)}
                className="rounded-none"
              />
            </div>
          </div>
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        className="w-full rounded-none"
        onClick={onAdd}
        data-testid="wizard-add-punto"
      >
        <Plus className="h-4 w-4 mr-2" />
        Aggiungi Punto Vendita
      </Button>
    </div>
  );
}
